import { InjectionToken } from '@angular/core';
import {
  InvoiceHistory,
  InvoiceHistorySearchResult,
  LastOrderedArticlesSearchResult,
  MostOrderedArticlesSearchResult,
  OrderDetails,
  OrderDetailsHighLevelItems,
  OrderDetailsOrderLine,
  OrderHistory,
  OrderHistorySearchResult,
  TrackedOrder,
} from '../../../core/model';
import { Occ } from '../../../core/occ/occ-models';
import { ShipToPage, SimpleCustomerPage } from '../../../core/occ/occ-models/occ-generated.models';
import { Converter } from '../../../core/util/converter.service';

export const TRACKED_ORDER_NORMALIZER = new InjectionToken<Converter<Occ.TrackOrderShipTo[], TrackedOrder>>(
  'TrackedOrderNormalizer'
);

export const ORDER_DETAILS_NORMALIZER = new InjectionToken<Converter<Occ.OrderDetailsOrder, OrderDetails>>(
  'OrderDetailsNormalizer'
);

export const ORDER_DETAILS_ORDER_LINE_NORMALIZER = new InjectionToken<
  Converter<Occ.OrderDetailsOrderLine, OrderDetailsOrderLine>
>('OrderDetailsOrderLineNormalizer');

export const ORDER_DETAILS_HIGH_LEVEL_ITEMS_NORMALIZER = new InjectionToken<
  Converter<Occ.OrderDetailsOrder['highLevelItems'], OrderDetailsHighLevelItems>
>('OrderDetailsHighLevelItemsNormalizer');

export const ORDER_HISTORY_NORMALIZER = new InjectionToken<Converter<Occ.OrderHistoryItem, OrderHistory>>(
  'OrderHistoryNormalizer'
);

export const ORDER_HISTORY_SEARCH_NORMALIZER = new InjectionToken<Converter<Occ.OrderHistoryPage, OrderHistorySearchResult>>(
  'OrderHistorySearchNormalizer'
);

export const ORDER_HISTORY_USERS_SEARCH_NORMALIZER = new InjectionToken<Converter<Occ.SimpleCustomerPage, SimpleCustomerPage>>(
  'OrderHistoryUsersSearchNormalizer'
);

export const ORDER_HISTORY_SHIPTOS_SEARCH_NORMALIZER = new InjectionToken<Converter<Occ.ShipToPage, ShipToPage>>(
  'OrderHistoryShiptosSearchNormalizer'
);

export const INVOICE_HISTORY_NORMALIZER = new InjectionToken<Converter<Occ.InvoiceHistoryRow, InvoiceHistory>>(
  'InvoiceHistoryNormalizer'
);

export const INVOICE_HISTORY_SEARCH_NORMALIZER = new InjectionToken<
  Converter<Occ.InvoiceHistoryPage, InvoiceHistorySearchResult>
>('InvoiceHistorySearchNormalizer');

export const LAST_MOST_ORDERED_ARTICLES_NORMALIZER = new InjectionToken<
  Converter<Occ.RefsSearchPage, LastOrderedArticlesSearchResult | MostOrderedArticlesSearchResult>
>('LastMostOrderedArticlesNormalizer');
